import React, {FC} from 'react';

import {Trans} from '../../../../libs/shared/core/src/helpers/internationalization/react';
import {usePush} from '../../../../libs/shared/core/src/services/push/pushContext';
import {
  InterfaceEventsEnum,
  trackInterfaceEvent,
} from '../../../../libs/shared/core/src/services/tracking/tracking';
import {AppContentTypesEnum} from '../../../../libs/shared/core/src/store/panels/app/commonAppPanelState';
import {AppPanelId} from '../../../../libs/shared/core/src/store/panels/panelStateBase';
import {useAppDispatch} from '../../../helpers/appReduxHelpers';
import {
  pushContentTypeAction,
  pushDefaultContentTypeAction,
} from '../../../store/panels/app/appPanelRouteActions';
import {TopBarButton} from './topBarButton';
import {TrackingLocationsEnum} from './topBarHelpers';

/*
 * Props.
 */

interface SettingsAppButtonProps {
  panelId: AppPanelId;
  isSelected: boolean;
}

/*
 * Component.
 */

export const SettingsAppButton: FC<SettingsAppButtonProps> = ({panelId, isSelected}) => {
  const {isConnected} = usePush();

  const dispatch = useAppDispatch();

  const onClick = () => {
    trackInterfaceEvent(InterfaceEventsEnum.NAVIGATION_CLICK, {
      object_name: 'settings',
      location: TrackingLocationsEnum.P0,
    });

    if (isSelected) {
      return dispatch(pushDefaultContentTypeAction(panelId));
    }

    return dispatch(pushContentTypeAction(panelId, AppContentTypesEnum.SETTINGS));
  };

  return (
    <TopBarButton
      isSelected={isSelected}
      isDisabled={!isConnected}
      onClick={onClick}
      shouldAllowClickWhenSelected
      renderTooltip={() => renderButtonTooltip(isSelected, isConnected)}
      iconName="gear"
      // @TODO: Reimplement smoke test.
      // For our Ghost Inspector production smoke test.
      interactionId="settings-button"
    />
  );
};

/*
 * Helpers.
 */

const renderButtonTooltip = (isSelected: boolean, isConnected: boolean) => {
  if (!isConnected && !isSelected) {
    return <Trans id="tab-offline-tooltip">Not available offline</Trans>;
  }

  return <Trans id="settingstopbar-tooltip">Settings</Trans>;
};
